import MenuMain from '../../MenuMain';
import { AppFooter } from '../../AppFooter';
import { DashBoard } from '../../components/DashBoard';

export default function HomeAdminPage() {

    return (<div>
        <MenuMain >
        <DashBoard />
        </MenuMain>
        <AppFooter />
    </div>
    );
}
